import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSessionStorage } from 'usehooks-ts';
import Routes from '../routes.enum.ts';
import RegistrationStepGuard from './RegistrationStepGuard.tsx';
import { UserRoles } from '../../constants/entities.ts';
import withMe, { MePropsType } from '../../hocs/withMe.tsx';
import { GO_TO_INVITE_MEMBERS } from '../../constants/config.ts';

type Props = MePropsType & {
  children: ReactNode;
};

const RegistrationRoutes = [Routes.ManagerEmailConfirmation, Routes.ManagerSetUp];

const ManagerRegistrationGuard: FC<Props> = ({ children, user }) => {
  const [goToInviteMembers] = useSessionStorage(GO_TO_INVITE_MEMBERS, false);

  const { emailConfirmed, personalProfileCompleted, isAgencySet, role } = user;

  if (role !== UserRoles.AgencyManager) {
    return children;
  }

  const isOnRegistrationStep = RegistrationRoutes.includes(window.location.pathname as Routes);

  // Check if all registration steps are completed
  const isRegistrationComplete = emailConfirmed && personalProfileCompleted && isAgencySet;

  return (
    <RegistrationStepGuard
      skipAhead={emailConfirmed}
      path={Routes.ManagerEmailConfirmation}
      rootChildren={children}
    >
      <RegistrationStepGuard
        skipAhead={personalProfileCompleted && isAgencySet}
        path={Routes.ManagerSetUp}
        rootChildren={children}
      >
        {isOnRegistrationStep && isRegistrationComplete ? (
          <Navigate
            to={goToInviteMembers ? Routes.ManagerInviteMembers : Routes.Dashboard}
            replace
          />
        ) : (
          children
        )}
      </RegistrationStepGuard>
    </RegistrationStepGuard>
  );
};

export default withMe(ManagerRegistrationGuard);
